import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Routes, Route, BrowserRouter as Router, Navigate } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

const today = new Date();

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route exact path="/" element={<Navigate to={`/carrulim/${today.toISOString().substring(0, 10)}`} />} />
        <Route path="/carrulim" element={<Navigate to={`/carrulim/${today.toISOString().substring(0, 10)}`} />} />
        <Route path="/carrulim/:dateParam" element={<App />} />
        <Route path="*" element={<Navigate to={`/carrulim/${today.toISOString().substring(0, 10)}`} />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
